"use client";
import { useCallback } from "react";
import { logout } from "redux-store/reducers";
import { store } from "redux-store/store";

export const useLogout = ({ redirectTo = "/login" }: { redirectTo?: string } = {}) => {
	const dispatch = store.dispatch;

	return useCallback(() => {
		dispatch(logout({}));
		if (typeof window !== "undefined") {
			window.location.href = redirectTo;
		}
	}, [dispatch, redirectTo]);
};
